import { Button } from "@hr-survey/ui";
import { useEffect, useState } from "react";
import { useThemeStore } from "~/stores/theme.store";

export function ThemeToggle() {
  const { theme, setTheme } = useThemeStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  // Reflect the currently displayed appearance so the toggle stays a simple
  // two-state light/dark switch even when the stored value is still "system".
  const isDark =
    mounted &&
    (theme === "dark" ||
      (theme === "system" && matchMedia("(prefers-color-scheme: dark)").matches));

  function toggle() {
    setTheme(isDark ? "light" : "dark");
  }

  const icon = isDark ? "☾" : "☀";
  const label = isDark ? "Dark" : "Light";

  return (
    <Button variant="ghost" size="sm" onClick={mounted ? toggle : undefined} title={label}>
      <span className="text-base">{icon}</span>
    </Button>
  );
}
